<template>
    <div class="row mb-4">
        <div class="col-sm-12">
            <div>
                <b-card no-body>
                    <b-tabs content-class="mt-3" fill>
                        <b-tab v-show="lots && lots.length > 0" v-for="(lot, indexLot) in lots" :key="indexLot"  :title="lot.name" :active="indexLot == 0">
                            <b-card-text class="ml-2 mr-2">
                                <h2 class="ix-page-title-secondary mt-4">Prévisions</h2>

                                <input type="hidden" class="form-control" :value="lot.id" :name="'lots[' + indexLot + '][lot_id]'">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="ix-table-box mb-3">
                                            <table class="ix-table">
                                                 <tr>
                                                    <th style="width: 30px;"></th>
                                                    <th style="width: 30px;">
                                                        <span data-toggle="tooltip" data-placement="top" title="Définir comme titre"><i class="far fa-text"></i></span>
                                                    </th>
                                                    <th style="width: 150px;">Catégorie</th>
                                                    <th style="width: 150px;">Référence</th>
                                                    <th>Désignation</th>
                                                    <th style="width: 120px;">Qté</th>
                                                    <th class="text-right" style="width: 180px;">Prix de revient HT</th>
                                                    <th class="text-center" style="width: 130px;">
                                                        Tx {{ margin_type == 2 ? 'marque' : 'marge' }}
                                                    </th>
                                                    <th class="text-right" style="width: 180px;">Prix de vente HT</th>
                                                    <th class="text-right" style="width: 180px;">Total vente HT</th>
                                                    <th class="text-center">
                                                            Injecter <br> dans le RAF
                                                            <span data-toggle="tooltip" data-placement="top" title="Cocher la prévision pour l’injecter dans le reste à faire">
                                                                <i class="fas fa-question-circle"></i>
                                                            </span>
                                                    </th>
                                                    <th style="width: 120px;"></th>
                                                </tr>
                                                  <draggable v-model="lot.predictions" tag="tbody" handle=".handle-line" v-if="!loading">
                                                    <tr v-for="(prediction, i) in lot.predictions" is="prediction-lot-line-form"
                                                        v-bind:key="prediction.uniq"
                                                        :ref="prediction.uniq"
                                                        :lot="lot"
                                                        :prediction="prediction"
                                                        :index="i"
                                                        :lot-index="indexLot"
                                                        :suggestionsRoute="suggestionsRoute"
                                                        :types="JSON.parse(predictionTypes)"
                                                        :purchase-types="JSON.parse(purchaseTypes)"
                                                        :default-margin-workforce="margin_workforce"
                                                        :default-margin-purchases="margin_purchases"
                                                        :default-margin-stocks="margin_stocks"
                                                        :default-margin-equipments="margin_equipments"
                                                        :default-hourly-rate="default_hourly_rate"
                                                        :margin-type="margin_type"
                                                        :manage-remaining="true"
                                                        v-on:prediction-editing-started="checkIfNewRowNeeded($event)"
                                                        v-on:prediction-deleted="deleteRow($event)"
                                                    ></tr>
                                                </draggable>
                                            </table>
                                        </div>
                                        <button type="button" class="ix-btn link" @click="addLotPredictionRow(indexLot)"><i class="far fa-plus"></i> Nouvelle prévision</button>
                                    </div>
                                </div>

                                <prediction-lot-synthesis-form :lot="lot" :index="indexLot" :is-deal="isDeal" :prediction-types="predictionTypes" :refs="$refs"></prediction-lot-synthesis-form>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Non alloties">
                            <b-card-text class="ml-2 mr-2"  >
                                <h2 class="ix-page-title-secondary mt-4">Prévisions</h2>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="ix-table-box mb-3">
                                            <table class="ix-table">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 30px;"></th>
                                                        <th style="width: 30px;">
                                                            <span data-toggle="tooltip" data-placement="top" title="Définir comme titre"><i class="far fa-text"></i></span>
                                                        </th>
                                                        <th style="width: 150px;">Catégorie</th>
                                                        <th style="width: 150px;">Référence</th>
                                                        <th>Désignation</th>
                                                        <th style="width: 120px;">Qté</th>
                                                        <th class="text-right" style="width: 180px;">Prix de revient HT</th>
                                                        <th class="text-center" style="width: 130px;">
                                                            Tx {{ margin_type == 2 ? 'marque' : 'marge' }}
                                                        </th>
                                                        <th class="text-right" style="width: 180px;">Prix de vente HT</th>
                                                        <th class="text-right" style="width: 180px;">Total vente HT</th>
                                                         <th class="text-center">
                                                            Injecter <br> dans le RAF
                                                            <span data-toggle="tooltip" data-placement="top" title="Cocher la prévision pour l’injecter dans le reste à faire">
                                                                <i class="fas fa-question-circle"></i>
                                                            </span>
                                                        </th>
                                                        <th style="width: 120px;"></th>
                                                    </tr>
                                                </thead>
                                                 <draggable v-model="predictions" tag="tbody" handle=".handle-line" v-if="!loading">
                                                    <tr v-for="(prediction, index) in predictions" is="prediction-form"
                                                        v-bind:key="prediction.uniq"
                                                        :ref="prediction.uniq"
                                                        :prediction="prediction"
                                                        :index="index"
                                                        :suggestionsRoute="suggestionsRoute"
                                                        :types="JSON.parse(predictionTypes)"
                                                        :purchase-types="JSON.parse(purchaseTypes)"
                                                        :default-margin-workforce="margin_workforce"
                                                        :default-margin-purchases="margin_purchases"
                                                        :default-margin-stocks="margin_stocks"
                                                        :default-margin-equipments="margin_equipments"
                                                        :default-hourly-rate="default_hourly_rate"
                                                        :margin-type="margin_type"
                                                        :manage-remaining="true"
                                                        v-on:prediction-editing-started="checkIfNewRowNeeded($event)"
                                                        v-on:prediction-deleted="deleteRow($event)"
                                                    ></tr>
                                                 </draggable>
                                            </table>
                                        </div>

                                        <button type="button" class="ix-btn link" @click="addRow(null)"><i class="far fa-plus"></i> Nouvelle prévision</button>
                                    </div>
                                </div>

                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>

import PredictionForm from "./PredictionForm";
import PredictionLotForm from "./PredictionLotForm.vue";
import PredictionLotSynthesisForm from "./PredictionLotSynthesisForm.vue";
import PredictionLotLineForm from "./PredictionLotLineForm.vue";
import draggable from 'vuedraggable';
import Swal from "sweetalert2";

export default {
    name: 'edit-prediction-table',
    props: ['suggestionsRoute', 'oldData', 'initialData', 'predictionTypes', 'purchaseTypes', 'isDeal', 'lotRoute', 'removeLotPrediction'],
    components : {
            PredictionForm,
            PredictionLotForm,
            PredictionLotSynthesisForm,
            PredictionLotLineForm,
            draggable
    },
    data() {
            return {
                loading: true,
                predictions: [],
                lots : [],

                quantity: null,
                unit: '',
                hours_per_day: 7,

                margin_type: 1,
                margin_workforce: 0,
                margin_purchases: 0,
                margin_stocks: 0,
                margin_equipments: 0,

                default_hourly_rate: 0,
                currentIndex: null,
                currentLot: null,
                canAddLot: true,
            };
    },
    methods: {
        addLotRow(lot, index){
                var data = {
                    id: null,
                    number: null,
                    name: '',
                    description: '',
                    quantity: null,
                    unit: '',
                    hours_per_day: this.hours_per_day,
                    margin_type: 1,
                    margin_workforce: 0,
                    margin_purchases: 0,
                    margin_stocks: 0,
                    margin_equipments: 0,
                    default_hourly_rate: 0,
                    predictions : [{
                        id: null,
                        uniq: Math.random().toString(36).substr(2, 9),
                        is_title: 0,
                        type: '',
                        type_secondary: 1,
                        reference: '',
                        designation: '',
                        quantity: 1,
                        unit: '',
                        amount: 0,
                        total: 0,
                        margin: 0,
                        selling: 0,
                        total_selling: 0,
                        remaining_selected: false,
                        has_remaining : false,
                        sync_remaining : false,
                    }],
                    uniq: Math.random().toString(36).substr(2, 9)
                };

                if(lot != null){
                    data.id = lot.id ? lot.id : null;
                    data.name = lot.name ? lot.name : null;
                    data.description = lot.description ? lot.description : null;
                    data.predictions = lot.predictions ? lot.predictions : null;
                    data.quantity = lot.lot_prediction && lot.lot_prediction. quantity ?lot.lot_prediction.quantity : null;
                    data.unit = lot.lot_prediction && lot.lot_prediction.unit ? lot.lot_prediction.unit : '';
                    data.hours_per_day = lot.lot_prediction && lot.lot_prediction.hours_per_day ? lot.lot_prediction.hours_per_day : this.hours_per_day;
                    data.margin_type = lot.lot_prediction && lot.lot_prediction.margin_type ? lot.lot_prediction.margin_type : this.margin_type;
                    data.margin_workforce = lot.lot_prediction && lot.lot_prediction.margin_workforce ? lot.lot_prediction.margin_workforce : this.margin_workforce;
                    data.margin_purchases = lot.lot_prediction && lot.lot_prediction.margin_purchases ? lot.lot_prediction.margin_purchases : this.margin_purchases;
                    data.margin_stocks = lot.lot_prediction && lot.lot_prediction.margin_stocks ? lot.lot_prediction.margin_stocks : this.margin_stocks;
                    data.margin_equipments = lot.lot_prediction && lot.lot_prediction.margin_equipments ? lot.lot_prediction.margin_equipments : this.margin_equipments;
                    data.remaining_selected = false;
                    data.has_remaining = lot.lot_prediction && lot.lot_prediction.has_remaining ? lot.lot_prediction.has_remaining : false;

                }

                this.lots.push(data);
        },
        checkIfNewRowNeeded: function (params) {
               /* if (this.predictions.length > 0 && this.lots.length == 0 && params.lot == null) {
                    if (this.predictions.length - 1 == params.index) {
                        this.addRow()
                    }
                } 

                if(this.lots.length > 0 && params.lot != null){
                    if(params.lot.predictions.length - 1 == params.index){
                        this.lots[params.lotIndex].predictions.push(
                            {
                                id: null,
                                uniq: Math.random().toString(36).substr(2, 9),
                                is_title: 0,
                                type: '',
                                type_secondary: 1,
                                reference: '',
                                designation: '',
                                quantity: 1,
                                unit: '',
                                amount: 0,
                                total: 0,
                                margin: 0,
                                selling: 0,
                                total_selling: 0,
                            }
                        );
                    }
                }*/
        },
        deleteRow: function (params) {
            if(this.predictions.length > 0 && !params.lot){
                if( this.predictions[params.index].id != null){
                     fetch('/api/removePrediction?prediction_id=' + this.predictions[params.index].id , {
                        ...{
                            method: 'DELETE'
                        },
                        ...this.getHttpJsonRequestHeaders()
                    }).then(async (response) => {
                        if (response.ok) {
                            this.predictions.splice(params.index, 1)
                        }
                    }).catch(error => {
                        console.log(error);
                    });
                } else {
                     this.predictions.splice(params.index, 1)
                }
               
            }
            
            if(this.lots.length > 0 && params.lot != null){
                    var lot = params.lot;
                    if(lot.predictions[params.index].id != null){
                        fetch('/api/removeLotPrediction?prediction_id=' + lot.predictions[params.index].id , {
                        ...{
                            method: 'DELETE'
                        },
                        ...this.getHttpJsonRequestHeaders()
                    }).then(async (response) => {
                        if (response.ok) {
                            lot.predictions.splice(params.index, 1);
                        }
                    }).catch(error => {
                        console.log(error);
                    })
                    } else {
                        lot.predictions.splice(params.index, 1);
                    }

            }
        },
        addLotPredictionRow: function(index){
            this.lots[index].predictions.push(
                {
                    id: null,
                    uniq: Math.random().toString(36).substr(2, 9),
                    is_title: 0,
                    type: '',
                    type_secondary: 1,
                    reference: '',
                    designation: '',
                    quantity: 1,
                    unit: '',
                    amount: 0,
                    total: 0,
                    margin: 0,
                    selling: 0,
                    total_selling: 0,
                    remaining_selected: false,
                    has_remaining : false,
                    sync_remaining : false,
                }
            );
        },
        addRow: function (prediction) {
                var data = {
                    id: null,
                    uniq: Math.random().toString(36).substr(2, 9),
                    is_title: 0,
                    type: '',
                    type_secondary: 1,
                    reference: '',
                    designation: '',
                    quantity: 1,
                    unit: '',
                    amount: 0,
                    total: 0,
                    margin: 0,
                    selling: 0,
                    total_selling: 0,
                    remaining_selected: false,
                    has_remaining: false,
                    sync_remaining: false,
                }

                if (prediction != null) {
                    data.id = prediction.id
                    data.is_title = prediction.is_title
                    data.type = prediction.type == null ? '' : prediction.type
                    data.type_secondary = prediction.type_secondary == null ? '' : prediction.type_secondary
                    data.reference = prediction.reference
                    data.designation = prediction.designation
                    data.description = prediction.description
                    data.quantity = prediction.quantity
                    data.unit = prediction.unit
                    data.amount = prediction.amount
                    data.margin = prediction.margin
                    data.selling = prediction.selling
                    data.lot_id = prediction.lot_id
                    data.has_remaining = prediction.has_remaining;
                }


                this.predictions.push(data)
        },
    },
    mounted(){
            const jsonDataBackup = JSON.parse(this.oldData)
            var jsonData = null
            this.loading = false

            if (Array.isArray(jsonDataBackup)) {
                jsonData = JSON.parse(this.initialData)
            } else {
                jsonData = jsonDataBackup
            }


            this.margin_type = jsonData.margin_type
            this.margin_workforce = jsonData.margin_workforce
            this.margin_purchases = jsonData.margin_purchases
            this.margin_stocks = jsonData.margin_stocks
            this.margin_equipments = jsonData.margin_equipments

             if (jsonData.predictions && Array.isArray(jsonData.predictions)) {
                
                jsonData.predictions.forEach((prediction) => {
                    this.addRow(prediction)
                })

            }

            if(jsonData.lots && typeof jsonData.lots === 'object'){
                const entries = Object.entries(jsonData.lots);
                
                entries.forEach((lot , index) => {
                    this.addLotRow(lot[1], 0);
                })
            }
     }
}
</script>